import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Header, Menu, Divider } from 'semantic-ui-react';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';

import Button from '@mui/material/Button';
import UploadFile from 'app/components/UploadFile';
import MessageModal from 'app/components/MessageModal';
import classes from './classes.module.scss';

import {
  GCLOUD_LOGO_TYPE
} from 'shared/utils/Constants';

import {
  updateAccount
} from 'app/services/accounts';

import {
  uploadAccountLogo,
  uploadAccountWatermark
} from 'app/actions/accounts';

const CompanyProfile = (props) => {
  const { account, uploadAccountLogo, uploadAccountWatermark } = props;
  const [loaded, setLoaded] = useState(true); // nothing to load yet
  const [message, setMessage] = useState(null);
  const [logoUrl, setLogoUrl] = useState(account.logo_url);
  const [watermarkUrl, setWatermarkUrl] = useState(account.watermark);

  const handleObjChange = (field, value) => {
    const obj = Object.assign({}, account);
    if (field === 'data_retention') {
      value = parseInt(value);
    }
    obj[field] = value;
    setAccount(obj);
  }

  const handleSave = () => {
    try {
      // Removing auto populated logo_url
      delete account.logo_url;
      updateAccount(account.id, account).then(() => {
        setMessage('Company profile successfully updated');
      })
    } catch (err) {
      setMessage(err);
    }
  }

  const handleWatermarkChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file) {
        uploadAccountWatermark(account.id, file.type, file).then((res) => {
          setWatermarkUrl(res.url);

          // Removing auto populated logo_url
          delete account.logo_url;
          const objAccount = { ...account, has_watermark: true };
          setAccount(objAccount);
          updateAccount(account.id, objAccount)
        })
      }
    }
  }

  const handleLogoChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file) {
        uploadAccountLogo(account.id, file.type, file).then((res) => {
          setLogoUrl(res.url);

          // Removing auto populated logo_url
          delete account.logo_url;
          const objAccount = { ...account, logo_type: GCLOUD_LOGO_TYPE };
          setAccount(objAccount);
          updateAccount(account.id, objAccount)
        })
      }
    }
  }
  const headerVariant = 'h6';

  return <div className={classes.container}>
    <Menu stackable secondary fluid>
      <Menu.Item>
        <Typography variant="h1">
          Company Profile
        </Typography>
      </Menu.Item>
      <Menu.Menu position='right'>
        <Button variant='contained' size='medium' sx={{ height: '3em' }} onClick={handleSave}>Update Profile</Button>
      </Menu.Menu>
    </Menu>
    <Divider />
    <div className={classes.form}>
      <span>
        {
          <img height={200} src={logoUrl} />
        }
        <br />
        <Header sub>JPEG, GIF, PNG at 300x300 pixels. This will appear with your photos.</Header>
        <UploadFile onFileChange={(e) => handleLogoChange(e)} />
      </span>
      <br />
      <TextField id="outlined-basic" value={account.name || ''} label="Company Name" variant="outlined" onChange={(e) => handleObjChange('name', e.target.value)} />
      <br />
      <TextField id="outlined-basic" value={account.website || ''} label="Website Address" variant="outlined" onChange={(e) => handleObjChange('website', e.target.value)} />
      <br />
      <TextField id="outlined-basic" value={account.contact_email || ''} label="Support Contact Email" variant="outlined" onChange={(e) => handleObjChange('contact_email', e.target.value)} />
      <br />
      <TextField
        id="outlined-basic"
        type="number"
        value={account.data_retention || 0}
        label="Data Retention"
        variant="outlined"
        hidden={!account.feature_flags.data_retention_enabled}
        onChange={(e) => handleObjChange('data_retention', e.target.value)}
        helperText='The number of days customer data and photos will be retained. WARNING: ALL photos, including purchased photos and photos from kiosk catalog jobs, older than the set number of days will be removed! Use caution when adjusting this setting and ensure jobs with default moments that should be retained were not associated with a kiosk by mistake!' />
    </div>
    <Header sub>Print Store Configuration</Header>
    <Divider />
    <div className={classes.form}>
      <TextField id="outlined-basic" value={account.print_store_url || ''} label="Print Store" variant="outlined" onChange={(e) => handleObjChange('print_store_url', e.target.value)} helperText='This Gooten store will open as the default print store.' />
    </div>
    <Header>Watermark</Header>
    <Divider />
    {
      account.has_watermark &&
      <div style={{ backgroundColor: "lightgray", height: "200px", width: "200px" }}>
        <img height={200} src={watermarkUrl} />
      </div>
    }
    <Header sub>PNG image file must be 3000x3000 pixels.</Header>
    <UploadFile onFileChange={(e) => handleWatermarkChange(e)} acceptedTypes='image/png' />
    <MessageModal
      isOpen={message !== null}
      onClose={() => setMessage(null)}
      title='Company Profile Update'
      headerVariant={headerVariant}
      message={message}
    />
  </div>
}

const mapStateToProps = state => ({
  account: state.portalReducer.account,
});

export default connect(mapStateToProps, { uploadAccountLogo, uploadAccountWatermark })(CompanyProfile);
